import api from '@/apis/di/collectionAgencyAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';
import indexedDB from '@/commons/indexedDB';

// Combo mã cơ quan thu
export const useCollectionAgencyCombo = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onCollectionAgencyComboboxLoadData = (payload, row, column) => {
    payload.filter = extendFilter(payload.filter);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  return {
    onCollectionAgencyComboboxLoadData,
  };
};
